import { StudentLayout } from '@/components/layout/student'
import { StudentRequestContent } from '@/components/layout/student/request-content'
import { useStudentSessionStore } from '@/store/student-session-store'
import { ExternalTransferPreviousEducationData } from '../../../components/student/transfer-steps/step-1/external-transfer-previous-education-data'
import { CheckTheEquivalences } from '../../../components/student/transfer-steps/step-2/check-the-equivalences'
import { useStudentCreditTransferForms } from './hooks/use-student-credit-transfer-form'
import { useSubmitStudentRequestsForm } from './hooks/use-submit-request-form'

export const StudentCreditTransferPage = () => {
  const {
    states: { formMethods, formMethodsIA }
  } = useStudentCreditTransferForms()

  const { courseName } = useStudentSessionStore()

  const {
    states: {
      currentStep,
      fileStatus,
      isPreviousEducationSavePending,
      isCourseEquivalencePending,
      isCourseEquivalenceSuccess,
      request,
      isPendingEquivalences,
      fileWarning,
      disabledButtons
    },
    actions: { handleBack, handleNext, uploadMutate }
  } = useSubmitStudentRequestsForm(formMethods, formMethodsIA)

  const requestLabel = 'Aproveitamento de Estudos'

  const steps = [
    {
      label: 'Curso Anterior',
      content: (
        <ExternalTransferPreviousEducationData
          requestLabel={requestLabel}
          fileStatus={fileStatus}
          formMethods={formMethods}
          uploadMutation={uploadMutate}
          request={request}
          fileWarning={fileWarning}
        />
      ),
      pendingSave: isPreviousEducationSavePending
    },
    {
      label: 'Disciplinas a Dispensar',
      content: (
        <CheckTheEquivalences
          formMethods={formMethods}
          formMethodsAI={formMethodsIA}
          isPendingEquivalenceGenerate={isPendingEquivalences}
          isPendingSubmit={isCourseEquivalencePending}
          fileStatus={fileStatus}
          isSuccessSubmit={isCourseEquivalenceSuccess}
          request={request}
        />
      ),
      pendingSave: isCourseEquivalencePending
    }
  ]

  return (
    <StudentLayout>
      <StudentRequestContent
        requestTitle={requestLabel}
        requestSubTitle="Curso para aproveitamento"
        steps={steps}
        currentStep={currentStep}
        handleNext={handleNext}
        fileStatus={fileStatus}
        handleBack={handleBack}
        request={request}
        disabledButtons={disabledButtons}
        transferCourse={courseName || ''}
        finishedTransfer={isCourseEquivalenceSuccess}
      />
    </StudentLayout>
  )
}
